import { render } from "./XRichText.vue?vue&type=template&id=3fbb4afa&scoped=true"
import script from "./XRichText.vue?vue&type=script&lang=js"
export * from "./XRichText.vue?vue&type=script&lang=js"

import "./XRichText.vue?vue&type=style&index=0&id=3fbb4afa&lang=less&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fbb4afa"]])

export default __exports__